export const isValueInDataSource = (e) => {
    const selectedItem = e.sender.list.find('li[id]');
    const isValid = selectedItem.length === 0 ? false : true;
    return isValid;
}